import React, {Component} from 'react';
import { connect } from "react-redux";
import axios from "axios";
import FormTemplate from "../common/form/FormTemplate";
import { setSelectedControlPanelType, UserPurgeNowControlPanelKey } from "../../redux/actions/controlPanelActions";
import configData from "../../config/config.json";
import Confirmation from '../../components/common/modal/Confirmation';
import Alert from '../../components/common/modal/Alert';
import { handleError } from '../../redux/actions/commonStuff';
import { LOADING_STATUES, ALERT_TYPES } from "../../components/constants/constants";
import moment from 'moment';

const componentName = UserPurgeNowControlPanelKey;

const matchDispatchToProps = (dispatch) => {
  return { 
    setSelectedControlPanelType: () => dispatch(setSelectedControlPanelType(componentName))
  }
}

class UserPurgeNow extends Component {

  state = {
    purgeDate: "",
    loadingStatus: "",
    message: "",
    showAlert: false,
    alertMessage: "",
    alertType: ALERT_TYPES.OK
  }

  showAlert = (alertMessage) => {
    this.setState({
      showAlert: true,
      alertMessage
    })
  }

  hideAlert = () => {
    this.setState({
      showAlert: false,
      alertMessage: "",
      alertType: ALERT_TYPES.OK
    })
  }

  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value
    })
  }

  showLoading = () => {
		if (this.state.loadingStatus === "") {
			this.setState({
				loadingStatus: LOADING_STATUES.LOADING
			})
			return true;
		}
		return false;
	}

  // Delete methods
  handleDeleteUser = () => {
    
    if (this.showLoading() === true) {
     
      axios.post(configData.LANDNOTIFICATION_SERVER_URL + "controlPanel/countyConfig/userPurgeNow", this.state, { withCredentials: true })
        .then(
          (response) => {
            this.setState({
              loadingStatus: ""
            }, () => this.showAlert(response.data.message));
          },
          (error) => {
            handleError(error, this.props.history);
          }
        );
    }
  }

	showDeleteConfirmation = (event) => {
		event.preventDefault();
		this.setState({
			showDeleteConfirmationDialog: true
		})
	}

	hideDeleteConfirmation = () => {
		this.setState({
			showDeleteConfirmationDialog: false
		})
	}
	// Delete methods - End

  
  handleDatePickerChange = (date) => {
    this.setState({
      purgeDate: moment(date).format('L')
    })
  }

	componentDidMount() {
    this.props.setSelectedControlPanelType();

    axios.get(configData.LANDNOTIFICATION_SERVER_URL + "controlPanel/countyConfig/userPurgeNow", { withCredentials: true })
    .then(
      (response) => {
        const content = response.data.content;
        this.setState( {
          purgeDate: content.purgeDate,
        });
      },
      (error) => {
        console.log(error);
      }
    );
    
  }
  
  render() {
    const formProps = {
      componentName: componentName,
      pageHeading: "User Admin - Purge Now",
      onChange: this.handleChange,
      onSubmit: this.showDeleteConfirmation,
      loadingIndicator: this.state.loadingStatus === LOADING_STATUES.LOADING,
      formGroupRows: [
        {
          formGroups: [{ id: 'purgeDate', label: 'Never logged in, created before', fieldType: 'date', handleDatePickerChange: this.handleDatePickerChange, value: this.state.purgeDate }]
        }
      ]
    }

    return (
      <>
      <FormTemplate {...formProps} />
      <Confirmation show={this.state.showDeleteConfirmationDialog} cancelConfirmation={this.hideDeleteConfirmation} proceedConfirmation={this.handleDeleteUser} question={'Delete users who have never logged in?'} />
      <Alert show={this.state.showAlert} hideAlert={this.hideAlert} message={this.state.alertMessage} type={this.state.alertType} />
      </>
     )
  }
}

export default connect(null, matchDispatchToProps)(UserPurgeNow);